// src/lib/utils.ts
import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { GoalDuration } from "../types/goals";
import { format, isValid } from "date-fns";
import { es } from "date-fns/locale";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getDayOfYear = (date: Date): number => {
  const start = new Date(date.getFullYear(), 0, 0);
  const diff = date.getTime() - start.getTime();
  const oneDay = 1000 * 60 * 60 * 24;
  return Math.floor(diff / oneDay);
};

export const getMockQuote = () => {
  const numberOfDayOfYear = getDayOfYear(new Date());
  return mockQuotes[numberOfDayOfYear % mockQuotes.length];
};

export const parsedParamsUrlForPagination = (params: {
  page?: number;
  limit?: number;
  completed?: boolean;
  duration?: GoalDuration;
  startDate?: Date;
  endDate?: Date;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      if (value instanceof Date) {
        queryParams.append(key, value.toISOString());
      } else {
        queryParams.append(key, String(value));
      }
    }
  });
  return queryParams.toString();
}

export const formatDate = (date: Date) => {
  try {


    if (!isValid(date)) {
      return 'Fecha inválida';
    }
    return format(date, 'd MMM yyyy', { locale: es });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Fecha inválida';
  }
};

const mockQuotes = [
  {
    author: "Marco Aurelio",
    text: "La felicidad de tu vida depende de la calidad de tus pensamientos.",
  },
  {
    author: "Séneca",
    text: "La felicidad es no necesitarla.",
  },
  {
    author: "Epicteto",
    text:
      "No son las cosas las que atormentan a los hombres, sino su opinión sobre ellas.",
  },
  {
    author: "Séneca",
    text: "Gran parte de la bondad consiste en querer ser bueno.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No actúes como si tuvieras mil años por delante. La muerte acecha. Sé bueno mientras vivas.",
  },
  {
    author: "Epicteto",
    text:
      "Si quieres ser feliz, deja de pensar en el pasado y en el futuro, concéntrate en el presente.",
  },
  {
    author: "Séneca",
    text: "La mayor revelación es el silencio de la contemplación.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Recuerda siempre que nada es para siempre, ni siquiera tus problemas.",
  },
  {
    author: "Epicteto",
    text:
      "Procura, ante todo, no ser culpable de lo que censuras en los demás.",
  },
  {
    author: "Séneca",
    text: "Nada se parece tanto a la injusticia como la justicia tardía.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Acepta lo que no puedes cambiar. Cambia lo que puedes y sé sabio para reconocer la diferencia.",
  },
  {
    author: "Epicteto",
    text:
      "La libertad se alcanza cuando dejamos de desear cosas que no dependen de nosotros.",
  },
  {
    author: "Séneca",
    text: "El hombre más poderoso es aquel que es dueño de sí mismo.",
  },
  {
    author: "Marco Aurelio",
    text:
      "La vida es corta; la única meta de la existencia es vivirla con rectitud y verdad.",
  },
  {
    author: "Epicteto",
    text: "No importa lo que te suceda, sino cómo reaccionas ante ello.",
  },
  {
    author: "Séneca",
    text:
      "La verdadera felicidad es disfrutar el presente sin depender ansiosamente del futuro.",
  },
  {
    author: "Marco Aurelio",
    text: "Observa tu mente. De lo que está llena, de eso se compone tu vida.",
  },
  {
    author: "Epicteto",
    text:
      "No esperes que los acontecimientos sucedan como deseas; deséales tal como suceden.",
  },
  {
    author: "Séneca",
    text:
      "Tan pronto como dejamos de buscar la aprobación externa, nos convertimos en dueños de nosotros mismos.",
  },
  {
    author: "Marco Aurelio",
    text: "El arte de vivir se asemeja más a la lucha que a la danza.",
  },
  {
    author: "Epicteto",
    text:
      "Evita juzgar. Primero comprende, luego acepta o rechaza, pero hazlo con sabiduría.",
  },
  {
    author: "Séneca",
    text:
      "No hay persona menos afortunada que la que nunca ha enfrentado adversidades.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Todo lo que escuchamos es una opinión, no un hecho; todo lo que vemos es una perspectiva, no la verdad.",
  },
  {
    author: "Epicteto",
    text:
      "Nunca te quejes; en lugar de ello, trabaja con lo que tienes para crear lo que quieres.",
  },
  {
    author: "Séneca",
    text:
      "Lo único que te pertenece es el presente. El pasado ya no existe y el futuro es incierto.",
  },
  {
    author: "Marco Aurelio",
    text: "Pase lo que pase, guíate por la razón y el sentido de la justicia.",
  },
  {
    author: "Epicteto",
    text: "Agradece cada dificultad, porque te enseña a ser más fuerte.",
  },
  {
    author: "Séneca",
    text: "Dominarse a uno mismo es la tarea más importante de todas.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Cuando te levantes por la mañana, piensa en el privilegio de estar vivo.",
  },
  {
    author: "Epicteto",
    text:
      "La prueba de un buen carácter es la paciencia con los defectos ajenos.",
  },
  {
    author: "Séneca",
    text:
      "La vida es como una obra de teatro: no importa cuánto dure, sino lo bien que se actúe.",
  },
  {
    author: "Marco Aurelio",
    text: "Haz cada cosa como si fuera lo último que vas a hacer en tu vida.",
  },
  {
    author: "Epicteto",
    text:
      "La clave de la libertad es comprender qué está bajo nuestro control y qué no.",
  },
  {
    author: "Séneca",
    text:
      "No preguntemos por la fecha del fin del mundo; es algo que sólo concierne a la Naturaleza.",
  },
  {
    author: "Marco Aurelio",
    text: "La mejor manera de defenderte es no parecerte a ellos.",
  },
  {
    author: "Epicteto",
    text: "Quien avanza con prudencia y persevera, alcanzará la meta.",
  },
  {
    author: "Séneca",
    text: "El que sufre antes de ser necesario, sufre más de lo necesario.",
  },
  {
    author: "Marco Aurelio",
    text: "Sé tolerante con los demás y estricto contigo mismo.",
  },
  {
    author: "Epicteto",
    text:
      "Sé fiel a lo que te dicta tu razón, y no a lo que otros esperan de ti.",
  },
  {
    author: "Séneca",
    text: "Es mejor no tener ningún plan que tener uno malo.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No vivas como si tuvieras diez mil años por delante. El destino está a la vuelta de la esquina.",
  },
  {
    author: "Epicteto",
    text:
      "Cuando culpes a otros de tus fracasos, es que no has aprendido la lección.",
  },
  {
    author: "Séneca",
    text: "Vivir con miedo es vivir a medias, y eso no es vivir en absoluto.",
  },
  {
    author: "Marco Aurelio",
    text: "Concéntrate en lo que realmente importa; lo demás es distracción.",
  },
  {
    author: "Epicteto",
    text: "Sé humilde al hablar, pero audaz al actuar con rectitud.",
  },
  {
    author: "Séneca",
    text:
      "La prueba más grande del coraje es soportar las derrotas sin perder la esperanza.",
  },
  {
    author: "Marco Aurelio",
    text: "Busca dentro de ti la fuente de la fuerza eterna.",
  },
  {
    author: "Epicteto",
    text: "La sabiduría no es saber muchas cosas, sino verlas con claridad.",
  },
  {
    author: "Séneca",
    text: "La ira es una locura temporal; domina tu carácter o te destruirá.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Todo lo que sucede, sucede como debe, y si observas con cuidado, verás que es así.",
  },
  {
    author: "Epicteto",
    text:
      "No busques la aprobación de los demás, busca la de tu propia conciencia.",
  },
  {
    author: "Séneca",
    text:
      "Lo que importa no es cuánto tiempo vivimos, sino qué hacemos con ese tiempo.",
  },
  {
    author: "Marco Aurelio",
    text: "Transforma tu mente y cambiarás tu destino.",
  },
  {
    author: "Epicteto",
    text:
      "Para tener un gran carácter, practica la paciencia en las pequeñas cosas.",
  },
  {
    author: "Séneca",
    text: "El hombre sabio se basta a sí mismo y se basta para ser feliz.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Al que te hiere, respóndele con compasión, porque él desconoce el bien.",
  },
  {
    author: "Epicteto",
    text: "Todo lo que valga la pena requiere esfuerzo.",
  },
  {
    author: "Séneca",
    text: "La mayor riqueza es contentarse con poco.",
  },
  {
    author: "Marco Aurelio",
    text: "El entendimiento correcto es el principio de la sabiduría.",
  },
  {
    author: "Epicteto",
    text:
      "Cuando cambias tu forma de ver las cosas, las cosas que ves cambian.",
  },
  {
    author: "Séneca",
    text:
      "La muerte es el último remedio, pero debemos usar los anteriores primero.",
  },
  {
    author: "Marco Aurelio",
    text:
      "El que vive en armonía consigo mismo, vive en armonía con el universo.",
  },
  {
    author: "Epicteto",
    text: "Solo te pertenecen tus acciones, no sus resultados.",
  },
  {
    author: "Séneca",
    text: "A quien sabe esperar, el tiempo le abre todas las puertas.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No malgastes más tiempo discutiendo sobre lo que es un buen hombre. Sé uno.",
  },
  {
    author: "Epicteto",
    text: "La autodisciplina es la clave de una vida sin remordimientos.",
  },
  {
    author: "Séneca",
    text: "El hombre no sufre por los hechos, sino por cómo los interpreta.",
  },
  {
    author: "Marco Aurelio",
    text: "Cuida de tu alma, pues todo lo demás está fuera de tu control.",
  },
  {
    author: "Epicteto",
    text: "Vive acorde a tus propios principios, no al juicio de los demás.",
  },
  {
    author: "Séneca",
    text: "El saber es la parte más considerable de la felicidad.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Lo que realmente da valor a la vida es la virtud y la rectitud de las acciones.",
  },
  {
    author: "Epicteto",
    text: "No confundas voluntad con terquedad, ni pasión con verdad.",
  },
  {
    author: "Séneca",
    text:
      "La pobreza no viene por la disminución de las riquezas, sino por la multiplicación de los deseos.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Si te perturba algo externo, el dolor no se debe a la cosa en sí, sino a tu juicio sobre ella.",
  },
  {
    author: "Epicteto",
    text:
      "Antes de abrir la boca, considera si tus palabras aportan justicia, verdad y bondad.",
  },
  {
    author: "Séneca",
    text: "Tan pronto como dejas de temer, eres libre.",
  },
  {
    author: "Marco Aurelio",
    text:
      "La humildad no te hace débil, te hace más fuerte y accesible al conocimiento.",
  },
  {
    author: "Epicteto",
    text:
      "No desees lo que no te pertenece. Aprende a desear lo que sí depende de ti.",
  },
  {
    author: "Séneca",
    text: "No es que la vida sea corta; es que perdemos mucho tiempo.",
  },
  {
    author: "Marco Aurelio",
    text: "La mejor venganza es ser diferente a quien te causó daño.",
  },
  {
    author: "Epicteto",
    text:
      "Cuida tus pensamientos, porque se convierten en tus palabras y acciones.",
  },
  {
    author: "Séneca",
    text: "El valor más grande está en el corazón tranquilo.",
  },
  {
    author: "Marco Aurelio",
    text: "Tu alma se tiñe con el color de tus pensamientos.",
  },
  {
    author: "Epicteto",
    text: "Ser disciplinado hoy te dará libertad mañana.",
  },
  {
    author: "Séneca",
    text: "Ganar sin riesgo es triunfar sin gloria.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Todo lo que necesitamos está en nuestro interior; lo externo es secundario.",
  },
  {
    author: "Epicteto",
    text:
      "No te inquietes por los obstáculos, son parte del camino y te forjan.",
  },
  {
    author: "Séneca",
    text: "Cuanto mayor es la dificultad, mayor es la gloria.",
  },
  {
    author: "Marco Aurelio",
    text: "¿Te preocupa el futuro? Haz ahora lo que creas correcto.",
  },
  {
    author: "Epicteto",
    text: "El primer paso hacia la sabiduría es admitir tu ignorancia.",
  },
  {
    author: "Séneca",
    text: "El sabio construye puentes con las piedras que otros le arrojan.",
  },
  {
    author: "Marco Aurelio",
    text: "Nada existe para siempre, salvo el presente.",
  },
  {
    author: "Epicteto",
    text: "La virtud es la recompensa que nunca falla.",
  },
  {
    author: "Séneca",
    text:
      "El éxito no consiste en vencer siempre, sino en no desanimarse nunca.",
  },
  {
    author: "Marco Aurelio",
    text: "Cada día ofrécete la oportunidad de ser mejor que ayer.",
  },
  {
    author: "Epicteto",
    text: "La grandeza del hombre está en saber dominarse a sí mismo.",
  },
  {
    author: "Séneca",
    text:
      "La voluntad de prepararse es tan importante como la voluntad de triunfar.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No juzgues a la naturaleza. Acepta lo que te ofrece y aprovéchalo sabiamente.",
  },
  {
    author: "Epicteto",
    text: "No dejes que tu alma se consuma por lo que no puedes controlar.",
  },
  {
    author: "Séneca",
    text:
      "La paciencia es la fortaleza del débil y la impaciencia la debilidad del fuerte.",
  },
  {
    author: "Marco Aurelio",
    text: "La fortaleza del carácter se cultiva a través de la adversidad.",
  },
  {
    author: "Epicteto",
    text:
      "Sigue tu razón, incluso si va en contra del criterio de la mayoría.",
  },
  {
    author: "Séneca",
    text: "El tiempo cura lo que la razón no puede.",
  },
  {
    author: "Marco Aurelio",
    text: "Vive de modo que tu vida sea digna de ser recordada.",
  },
  {
    author: "Epicteto",
    text: "La mayor victoria es conquistarte a ti mismo.",
  },
  {
    author: "Séneca",
    text: "Es inútil huir de los defectos si no te liberas de tus hábitos.",
  },
  {
    author: "Marco Aurelio",
    text: "La muerte sonríe a todos; el hombre sabio devuelve la sonrisa.",
  },
  {
    author: "Epicteto",
    text: "El poder más grande lo tiene aquel que domina sus pasiones.",
  },
  {
    author: "Séneca",
    text:
      "Nada es más despreciable que la vida de aquel que se consume en placeres sin fin.",
  },
  {
    author: "Marco Aurelio",
    text: "No lamentes lo que perdiste, celebra lo que viviste.",
  },
  {
    author: "Epicteto",
    text:
      "Lo que importa no es lo que te sucede, sino cómo reaccionas ante ello.",
  },
  {
    author: "Séneca",
    text:
      "Ningún viento es favorable para el que no sabe a qué puerto se dirige.",
  },
  {
    author: "Marco Aurelio",
    text: "Si te concentras en ser mejor, no tendrás tiempo para quejarte.",
  },
  {
    author: "Epicteto",
    text: "La adversidad revela el carácter, no lo crea.",
  },
  {
    author: "Séneca",
    text: "El mejor consejo: conócete a ti mismo.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Todo lo que necesitas para vivir una buena vida, ya lo posees en tu interior.",
  },
  {
    author: "Epicteto",
    text: "Si tuviéramos la paciencia de escuchar, aprenderíamos de todos.",
  },
  {
    author: "Séneca",
    text: "Sólo es sabio quien sigue aprendiendo de la vida misma.",
  },
  {
    author: "Marco Aurelio",
    text: "El mejor refugio está en tu mente virtuosa.",
  },
  {
    author: "Epicteto",
    text:
      "No te rindas ante los fracasos. Cada uno es una lección que te impulsa hacia la virtud.",
  },
  {
    author: "Séneca",
    text: "El momento presente es lo único que realmente tienes.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Guarda la calma incluso en la tormenta; la serenidad es tu gran aliada.",
  },
  {
    author: "Epicteto",
    text: "No seas esclavo de tus deseos. Aprende a gobernarlos con razón.",
  },
  {
    author: "Séneca",
    text:
      "Tu alma es tu tesoro más preciado; no la entregues a quien no la sepa valorar.",
  },
  {
    author: "Marco Aurelio",
    text: "Nada que valga la pena se consigue sin un esfuerzo persistente.",
  },
  {
    author: "Epicteto",
    text: "Cada error es una oportunidad de aprendizaje.",
  },
  {
    author: "Séneca",
    text: "Para vivir libremente, vive sin miedo a la muerte.",
  },
  {
    author: "Marco Aurelio",
    text: "La simplicidad es la clave de la verdadera grandeza.",
  },
  {
    author: "Epicteto",
    text: "Libérate del resentimiento y encontrarás la verdadera paz.",
  },
  {
    author: "Séneca",
    text: "El hombre sufre más en la imaginación que en la realidad.",
  },
  {
    author: "Marco Aurelio",
    text: "Cada vez que te enojes, pregúntate si realmente vale la pena.",
  },
  {
    author: "Epicteto",
    text: "No persigas la aprobación ajena; persigue tu propia excelencia.",
  },
  {
    author: "Séneca",
    text: "La bondad enriquece al que la da y al que la recibe.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Solo el presente está en tus manos; el pasado y el futuro escapan a tu control.",
  },
  {
    author: "Epicteto",
    text:
      "Ten la humildad de aceptar tus errores y la fortaleza de corregirlos.",
  },
  {
    author: "Séneca",
    text:
      "Es más valiente el que vence sus deseos que el que conquista ciudades.",
  },
  {
    author: "Marco Aurelio",
    text: "La comprensión de uno mismo es la puerta a la sabiduría universal.",
  },
  {
    author: "Epicteto",
    text: "Lo que importa es la intención correcta, no la opinión ajena.",
  },
  {
    author: "Séneca",
    text:
      "Vive cada día como si fuera el último, pero prepárate como si fueras inmortal.",
  },
  {
    author: "Marco Aurelio",
    text: "Aprende a estar en calma en la más profunda confusión.",
  },
  {
    author: "Epicteto",
    text:
      "La virtud no se compra, se conquista a través de la práctica diaria.",
  },
  {
    author: "Séneca",
    text: "Si quieres ser amado, ama.",
  },
  {
    author: "Marco Aurelio",
    text: "Saber vivir es saber morir en cada momento, sin apego.",
  },
  {
    author: "Epicteto",
    text: "Solo es libre aquel que ha conquistado sus miedos.",
  },
  {
    author: "Séneca",
    text: "El reposo sin estudio es letargo, y el estudio sin reposo, fatiga.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Piensa con claridad, actúa con determinación y ama con generosidad.",
  },
  {
    author: "Epicteto",
    text: "El secreto para ser feliz es valorar lo que ya tienes.",
  },
  {
    author: "Séneca",
    text: "No vivas al ritmo de las pasiones, sino al compás de la razón.",
  },
  {
    author: "Marco Aurelio",
    text: "Nada es difícil si lo desmenuzas en pequeños pasos.",
  },
  {
    author: "Epicteto",
    text: "Las acciones hablan más alto que cualquier palabra o promesa.",
  },
  {
    author: "Séneca",
    text: "Busca en tu interior la respuesta que te niega el mundo.",
  },
  {
    author: "Marco Aurelio",
    text: "Donde no hay lucha, no hay fuerza.",
  },
  {
    author: "Epicteto",
    text:
      "Acepta la responsabilidad de tus actos y hallarás libertad en tu espíritu.",
  },
  {
    author: "Séneca",
    text: "El que con poco se contenta, siempre tendrá suficiente.",
  },
  {
    author: "Marco Aurelio",
    text: "La vida se mide por la virtud, no por la duración.",
  },
  {
    author: "Epicteto",
    text: "Aquel que triunfa sobre sí mismo nunca será dominado.",
  },
  {
    author: "Séneca",
    text: "El hombre sabio piensa antes de hablar y actúa antes de lamentar.",
  },
  {
    author: "Marco Aurelio",
    text: "No busques la fama; busca la excelencia en tus acciones.",
  },
  {
    author: "Epicteto",
    text: "La gratitud es el atajo más directo a la paz mental.",
  },
  {
    author: "Séneca",
    text: "Nunca es largo el camino que conduce a la grandeza.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Libera tu mente de temores infundados y verás cómo surge la claridad.",
  },
  {
    author: "Epicteto",
    text:
      "La prosperidad pone a prueba nuestra bondad, y la adversidad, nuestro temple.",
  },
  {
    author: "Séneca",
    text:
      "La mente noble no se deja corromper ni por la riqueza ni por la pobreza.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Solo tienes poder sobre tu propia mente, no sobre los sucesos externos.",
  },
  {
    author: "Epicteto",
    text: "Para vivir en paz, aprende a no ofenderte con facilidad.",
  },
  {
    author: "Séneca",
    text: "Cuanto más grande es el desafío, más gloria hay en superarlo.",
  },
  {
    author: "Marco Aurelio",
    text: "El cambio es la única constante; acéptalo y fluye con él.",
  },
  {
    author: "Epicteto",
    text:
      "El que vive con sensatez no teme a la muerte, porque vive con plenitud.",
  },
  {
    author: "Séneca",
    text:
      "La fortaleza se muestra en la adversidad, y la verdadera sabiduría en la humildad.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No te resientas ni te irrites; conviértete en un ejemplo de ecuanimidad.",
  },
  {
    author: "Epicteto",
    text: "Cada día es una nueva oportunidad para forjar tu carácter.",
  },
  {
    author: "Séneca",
    text: "No compitas con los demás, compite contigo mismo.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Observa la naturaleza para comprender que todo pasa y se transforma.",
  },
  {
    author: "Epicteto",
    text: "No pierdas la serenidad por eventos que no controlas.",
  },
  {
    author: "Séneca",
    text:
      "Aprende a ser tu propio amigo; es la mejor compañía que podrás tener.",
  },
  {
    author: "Marco Aurelio",
    text: "Vive con justicia, actúa con bondad y habla con verdad.",
  },
  {
    author: "Epicteto",
    text: "La constancia en la disciplina forja el carácter virtuoso.",
  },
  {
    author: "Séneca",
    text: "El valor se demuestra enfrentando lo que temes.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Reflexiona antes de actuar, y actúa con rectitud después de reflexionar.",
  },
  {
    author: "Epicteto",
    text: "Lo que verdaderamente necesitamos es menos de lo que creemos.",
  },
  {
    author: "Séneca",
    text: "La mayor riqueza es la sabiduría y el bien obrar.",
  },
  {
    author: "Marco Aurelio",
    text: "Eres lo que piensas y haces repetidamente.",
  },
  {
    author: "Epicteto",
    text:
      "El verdadero honor no está en el reconocimiento, sino en la integridad.",
  },
  {
    author: "Séneca",
    text: "No concedas importancia a lo efímero, concéntrate en lo esencial.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Separa lo que está bajo tu control de lo que no. Ahí radica tu serenidad.",
  },
  {
    author: "Epicteto",
    text: "El autoconocimiento es el comienzo de toda mejora.",
  },
  {
    author: "Séneca",
    text: "Nunca seas esclavo de tus emociones; hazlas tus aliadas.",
  },
  {
    author: "Marco Aurelio",
    text: "La adversidad revela la grandeza del espíritu.",
  },
  {
    author: "Epicteto",
    text: "Mantén tu mente libre de prejuicios y abierta al aprendizaje.",
  },
  {
    author: "Séneca",
    text: "Cuando todo se dificulta, la constancia es la mejor aliada.",
  },
  {
    author: "Marco Aurelio",
    text: "No te dejes llevar por lo que sucede; guíate por tus principios.",
  },
  {
    author: "Epicteto",
    text: "La libertad interior nace cuando dejas de buscar culpas externas.",
  },
  {
    author: "Séneca",
    text: "El afán por las posesiones te hace pobre; la virtud te hace rico.",
  },
  {
    author: "Marco Aurelio",
    text: "Cultiva tu mente con buenos pensamientos, y tu vida florecerá.",
  },
  {
    author: "Epicteto",
    text:
      "La grandeza de un hombre no está en su fama, sino en su nobleza de espíritu.",
  },
  {
    author: "Séneca",
    text: "No hay nada más poderoso que la voluntad bien orientada.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No dejes que el miedo controle tus decisiones; actúa con razón y valentía.",
  },
  {
    author: "Epicteto",
    text: "Aquello que no dominas, te domina a ti.",
  },
  {
    author: "Séneca",
    text: "El conocimiento sin práctica es estéril.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Todo lo que te sucede es parte de un gran diseño. Aprovéchalo para crecer.",
  },
  {
    author: "Epicteto",
    text: "El que conoce sus limitaciones se hace inmenso en la humildad.",
  },
  {
    author: "Séneca",
    text: "El que vive para complacer a todos, no se complace a sí mismo.",
  },
  {
    author: "Marco Aurelio",
    text: "No te ahogues en la preocupación; la vida fluye y todo pasa.",
  },
  {
    author: "Epicteto",
    text:
      "Si te aferras a las cosas efímeras, tu felicidad será efímera también.",
  },
  {
    author: "Séneca",
    text:
      "La vejez llega pronto, pero la sabiduría puede llegar tarde. Aprovéchala.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Desarrolla la fortaleza para aceptar lo inevitable y la voluntad para cambiar lo que puedes.",
  },
  {
    author: "Epicteto",
    text: "No exijas del mundo lo que no te exiges a ti mismo.",
  },
  {
    author: "Séneca",
    text:
      "Aprecia la vida como un regalo frágil y efímero; entonces tendrás la urgencia de vivir bien.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Permanece fiel a tus principios, incluso cuando el mundo se oponga.",
  },
  {
    author: "Epicteto",
    text: "Antes de enojarte, pregúntate: ¿vale la pena perder la paz?",
  },
  {
    author: "Séneca",
    text: "El trabajo honesto ennoblece y el ocio injustificado corrompe.",
  },
  {
    author: "Marco Aurelio",
    text: "No hay mayor poder que el autocontrol.",
  },
  {
    author: "Epicteto",
    text: "La mente es tu morada, cuídala con esmero.",
  },
  {
    author: "Séneca",
    text: "La vida no exige ser perfecto, solo ser auténtico.",
  },
  {
    author: "Marco Aurelio",
    text: "Tu propósito debe ser obrar con bondad, sin esperar recompensas.",
  },
  {
    author: "Epicteto",
    text: "El valor nace de la convicción, no de la arrogancia.",
  },
  {
    author: "Séneca",
    text: "No dejes que el temor te impida actuar en favor de la justicia.",
  },
  {
    author: "Marco Aurelio",
    text: "Agradece lo que tienes hoy; mañana es incierto.",
  },
  {
    author: "Epicteto",
    text: "Aprende a soportar la injuria con dignidad.",
  },
  {
    author: "Séneca",
    text:
      "El alivio más grande para un alma afligida es la comprensión de su propia fuerza.",
  },
  {
    author: "Marco Aurelio",
    text: "El placer engaña, la virtud permanece.",
  },
  {
    author: "Epicteto",
    text: "Donde no hay tolerancia, no puede haber libertad.",
  },
  {
    author: "Séneca",
    text: "La soledad no es un castigo; puede ser un refugio para el sabio.",
  },
  {
    author: "Marco Aurelio",
    text: "Las crisis son oportunidades de transformación interior.",
  },
  {
    author: "Epicteto",
    text: "No te compares con los demás, compárate con tu versión anterior.",
  },
  {
    author: "Séneca",
    text:
      "El único viaje imprescindible es el que hacemos hacia nuestro interior.",
  },
  {
    author: "Marco Aurelio",
    text:
      "Comprende que el universo es cambio y tu vida es producto de tu pensamiento.",
  },
  {
    author: "Epicteto",
    text: "Lo que hagas hoy construirá tu carácter para mañana.",
  },
  {
    author: "Séneca",
    text: "El amor por la sabiduría es la guía de la vida recta.",
  },
  {
    author: "Marco Aurelio",
    text: "El enojo nunca soluciona nada; la razón lo soluciona todo.",
  },
  {
    author: "Epicteto",
    text: "La fuerza mental se nutre de la aceptación de la realidad.",
  },
  {
    author: "Séneca",
    text: "Sé parte de la curación, no del conflicto.",
  },
  {
    author: "Marco Aurelio",
    text: "Permanece íntegro aunque a tu alrededor reine la corrupción.",
  },
  {
    author: "Epicteto",
    text: "Cada persona es una historia diferente, no juzgues sin saber.",
  },
  {
    author: "Séneca",
    text: "La paciencia es el arte de la esperanza.",
  },
  {
    author: "Marco Aurelio",
    text: "Haz lo correcto, sin importar la consecuencia.",
  },
  {
    author: "Epicteto",
    text: "No esperes la perfección en los demás si no la practicas tú mismo.",
  },
  {
    author: "Séneca",
    text: "La envidia es un veneno que te consume por dentro.",
  },
  {
    author: "Marco Aurelio",
    text: "Renuncia a la queja y gana el control de tu mente.",
  },
  {
    author: "Epicteto",
    text: "Pocos ven lo que eres; todos ven lo que aparentas.",
  },
  {
    author: "Séneca",
    text: "Mejor es aprender tarde que no aprender nunca.",
  },
  {
    author: "Marco Aurelio",
    text: "El ayer ya pasó, el futuro es incierto; vive hoy con virtud.",
  },
  {
    author: "Epicteto",
    text: "No es grande el que nunca falla, sino el que nunca se rinde.",
  },
  {
    author: "Séneca",
    text: "El silencio puede ser más elocuente que mil palabras.",
  },
  {
    author: "Marco Aurelio",
    text: "Las opiniones ajenas no deben dictar tu vida.",
  },
  {
    author: "Epicteto",
    text:
      "La calma de la mente llega cuando dejas de obsesionarte con lo incontrolable.",
  },
  {
    author: "Séneca",
    text:
      "Más sabio es quien se conoce a sí mismo que quien conoce al universo.",
  },
  {
    author: "Marco Aurelio",
    text: "No permitas que el orgullo te impida aprender de los demás.",
  },
  {
    author: "Epicteto",
    text: "La humildad abre las puertas del entendimiento.",
  },
  {
    author: "Séneca",
    text: "La palabra es poderosa; úsala con responsabilidad.",
  },
  {
    author: "Marco Aurelio",
    text: "La virtud es la única riqueza que no pierde valor.",
  },
  {
    author: "Epicteto",
    text: "Sé siempre agradecido, aun en la dificultad.",
  },
  {
    author: "Séneca",
    text: "El amor verdadero no busca poseer, sino comprender.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No sufras más de lo necesario. El dolor es inevitable, el sufrimiento opcional.",
  },
  {
    author: "Epicteto",
    text: "Esclavo no es el que obedece, sino el que cede a sus pasiones.",
  },
  {
    author: "Séneca",
    text: "La paz interior proviene de la aceptación y la sabiduría.",
  },
  {
    author: "Marco Aurelio",
    text: "Lo importante no es lo que ocurre, sino cómo lo percibes.",
  },
  {
    author: "Epicteto",
    text:
      "No juzgues tu progreso comparándolo con el de otros; cada senda es única.",
  },
  {
    author: "Séneca",
    text:
      "La verdadera prueba de tu carácter es lo que haces cuando nadie te ve.",
  },
  {
    author: "Marco Aurelio",
    text:
      "La coherencia entre pensamiento, palabra y acción es la base de la paz interior.",
  },
  {
    author: "Epicteto",
    text: "Tus acciones definen tu identidad, no tus palabras.",
  },
  {
    author: "Séneca",
    text:
      "No permitas que el dinero gobierne tu espíritu; sé gobernado por la virtud.",
  },
  {
    author: "Marco Aurelio",
    text: "Elige ser amable y verás cómo todo cambia a tu alrededor.",
  },
  {
    author: "Epicteto",
    text:
      "Cuida lo que siembras en tu mente; de ello depende la cosecha de tu vida.",
  },
  {
    author: "Séneca",
    text: "La nobleza no está en la sangre, sino en las acciones.",
  },
  {
    author: "Marco Aurelio",
    text:
      "No te exaltes en el éxito ni te hundas en el fracaso; mantén el equilibrio.",
  },
  {
    author: "Epicteto",
    text:
      "El dolor no es eterno, pero tu reacción a él puede marcarte para siempre.",
  },
  {
    author: "Séneca",
    text: "La vida enseña a quien se presta a aprender.",
  },
  {
    author: "Marco Aurelio",
    text: "Honra la verdad, aunque sea incómoda.",
  },
  {
    author: "Epicteto",
    text: "Sé leal a tus principios, incluso en la adversidad.",
  },
  {
    author: "Séneca",
    text: "Controla tus ambiciones y hallarás la paz.",
  },
  {
    author: "Marco Aurelio",
    text: "El equilibrio mental es la llave de la serenidad.",
  },
  {
    author: "Epicteto",
    text: "Cada paso hacia la virtud es un paso hacia la libertad.",
  },
  {
    author: "Séneca",
    text: "La constancia en la búsqueda del bien es la esencia de la nobleza.",
  },
  {
    author: "Marco Aurelio",
    text: "Si algo es posible para el hombre, es posible para ti.",
  },
  {
    author: "Epicteto",
    text: "El verdadero amor nace cuando dejas de poner condiciones.",
  },
  {
    author: "Séneca",
    text: "Vive sin fingir y ama sin depender.",
  },
  {
    author: "Marco Aurelio",
    text: "Solo en el silencio escuchas la voz de la sabiduría.",
  },
  {
    author: "Epicteto",
    text: "La venganza daña más a quien la planifica que a quien la recibe.",
  },
  {
    author: "Séneca",
    text: "Abandona el pasado y enfócate en lo que puedes hacer hoy.",
  },
  {
    author: "Marco Aurelio",
    text: "El mejor maestro que tendrás es tu propia vida.",
  },
  {
    author: "Epicteto",
    text: "No hay fortaleza más grande que la honestidad con uno mismo.",
  },
  {
    author: "Séneca",
    text: "El tiempo es la moneda de tu vida; úsalo con sabiduría.",
  },
  {
    author: "Marco Aurelio",
    text: "Atiende a tu naturaleza, que es la razón y la compasión.",
  },
  {
    author: "Epicteto",
    text: "Saber lo que es bueno y no hacerlo es un defecto de voluntad.",
  },
  {
    author: "Séneca",
    text: "El único fracaso real es no intentarlo.",
  },
  {
    author: "Marco Aurelio",
    text: "Elimina lo innecesario y encontrarás la esencia de la vida.",
  },
  {
    author: "Epicteto",
    text:
      "La duda es el principio de la sabiduría, si te impulsa a buscar la verdad.",
  },
  {
    author: "Séneca",
    text: "El infortunio pone a prueba la amistad verdadera.",
  },
  {
    author: "Marco Aurelio",
    text: "Elimina el ego y encontrarás la paz.",
  },
  {
    author: "Epicteto",
    text: "No vivas para complacer a los demás; vive para ser tú mismo.",
  },
  {
    author: "Séneca",
    text: "El ocio bien empleado es el mejor descanso para el alma.",
  },
  {
    author: "Marco Aurelio",
    text: "Aléjate de la vanidad, acércate a la verdad.",
  },
  {
    author: "Epicteto",
    text: "La disciplina te libera de la esclavitud del desenfreno.",
  },
  {
    author: "Séneca",
    text:
      "Nunca desesperes en medio de las dificultades; ellas son tu oportunidad de crecer.",
  },
  {
    author: "Marco Aurelio",
    text: "La voluntad recta triunfa sobre la adversidad.",
  },
  {
    author: "Epicteto",
    text: "La constancia te asegura la victoria sobre ti mismo.",
  },
  {
    author: "Séneca",
    text:
      "La pobreza puede ser un lujo para quien valora más la virtud que la riqueza.",
  },
  {
    author: "Marco Aurelio",
    text: "Sé justo y firme, como la roca que no se doblega al oleaje.",
  },
  {
    author: "Epicteto",
    text: "Aprecia la vida simple; en ella reside la verdadera dicha.",
  },
  {
    author: "Séneca",
    text: "Tener pocas necesidades es el camino a la verdadera libertad.",
  },
  {
    author: "Marco Aurelio",
    text: "Ordena tu mente y tu vida se ordenará.",
  },
  {
    author: "Epicteto",
    text: "No temas a la soledad; es un encuentro contigo mismo.",
  },
  {
    author: "Séneca",
    text: "Lo necesario nunca es demasiado costoso.",
  },
  {
    author: "Marco Aurelio",
    text: "Quien domina su ira domina su vida.",
  },
  {
    author: "Epicteto",
    text:
      "La libertad auténtica consiste en no desear lo que está fuera de tu control.",
  },
  {
    author: "Séneca",
    text:
      "El sabio no se lamenta por lo que falta, sino que agradece lo que posee.",
  },
  {
    author: "Marco Aurelio",
    text:
      "La serenidad proviene de la armonía interna, no de las circunstancias externas.",
  },
  {
    author: "Epicteto",
    text: "Confía en tu capacidad de aprender y evolucionar.",
  },
  {
    author: "Séneca",
    text: "La constancia en la virtud forja la grandeza del espíritu.",
  },
  {
    author: "Marco Aurelio",
    text: "Sé dueño de tu mente y no esclavo de tus impulsos.",
  },
  {
    author: "Epicteto",
    text: "Aligera tu carga soltando el resentimiento.",
  },
  {
    author: "Séneca",
    text: "El perdón libera más a quien lo da que a quien lo recibe.",
  },
  {
    author: "Marco Aurelio",
    text: "La gratitud es la memoria del corazón.",
  },
  {
    author: "Epicteto",
    text: "Jamás te arrepentirás de un acto bondadoso.",
  },
  {
    author: "Séneca",
    text:
      "Las palabras pueden herir más que las armas, elige bien cómo las usas.",
  },
  {
    author: "Marco Aurelio",
    text: "El valor de una persona se mide por la rectitud de sus actos.",
  },
  {
    author: "Epicteto",
    text: "No envidies la felicidad ajena, crea la tuya propia.",
  },
  {
    author: "Séneca",
    text: "La humildad te hace grande ante tus propios ojos.",
  },
  {
    author: "Marco Aurelio",
    text: "No temas al cambio; más bien témele a la inacción.",
  },
  {
    author: "Epicteto",
    text: "Donde reina la razón, la pasión se convierte en energía creadora.",
  },
  {
    author: "Séneca",
    text: "Se corrompe el que vive sin propósito y sin virtud.",
  },
  {
    author: "Marco Aurelio",
    text: "Trata a todos con justicia, sin olvidar la misericordia.",
  },
  {
    author: "Epicteto",
    text: "La autocrítica constructiva es el camino a la superación.",
  },
  {
    author: "Séneca",
    text:
      "Solamente cuando estás en paz contigo mismo puedes estar en paz con los demás.",
  },
  {
    author: "Marco Aurelio",
    text: "Vive como si cada acto fuera a definirte para siempre.",
  },
  {
    author: "Epicteto",
    text: "El verdadero valor se mide en los momentos de mayor dificultad.",
  },
  {
    author: "Séneca",
    text: "Evita el exceso en todo; la moderación es una virtud estoica.",
  },
  {
    author: "Marco Aurelio",
    text: "No dejes que el estrés exterior perturbe tu mundo interior.",
  },
  {
    author: "Epicteto",
    text: "Cada desafío es un peldaño para la grandeza de tu espíritu.",
  },
  {
    author: "Séneca",
    text:
      "No importa cuán largo sea el camino; lo importante es no dejar de avanzar.",
  },
  {
    author: "Marco Aurelio",
    text: "Vive acorde con la naturaleza y hallarás la armonía.",
  },
  {
    author: "Epicteto",
    text:
      "Cuando controlas tus expectativas, nada te sorprende negativamente.",
  },
  {
    author: "Séneca",
    text: "La meditación diaria sobre la mortalidad da valor a la vida.",
  },
  {
    author: "Marco Aurelio",
    text: "El verdadero líder predica con el ejemplo, no con discursos.",
  },
  {
    author: "Epicteto",
    text: "Quien vive con virtud jamás vive en vano.",
  },
  {
    author: "Séneca",
    text: "La peor pobreza es la del espíritu conformista.",
  },
  {
    author: "Marco Aurelio",
    text: "Afronta cada momento con coraje y rectitud.",
  },
  {
    author: "Epicteto",
    text: "El dominio del alma es el paso a la verdadera libertad.",
  },
  {
    author: "Séneca",
    text: "Las grandes conquistas comienzan dominando el propio carácter.",
  },
  {
    author: "Marco Aurelio",
    text: "Mide tus actos por el bien que generen.",
  },
  {
    author: "Epicteto",
    text: "Si buscas la verdad, prepárate para vivir con honestidad.",
  },
  {
    author: "Séneca",
    text: "La sabiduría no envejece, se refina con el tiempo.",
  },
  {
    author: "Marco Aurelio",
    text: "Ante la duda, elige el camino de la bondad.",
  },
  {
    author: "Epicteto",
    text: "El silencio contemplativo cura la mente inquieta.",
  },
  {
    author: "Séneca",
    text:
      "La abundancia llega al que no mendiga favores sino que trabaja con dignidad.",
  },
  {
    author: "Marco Aurelio",
    text: "No te lamentes de tus deberes; cumple con ellos con alegría.",
  },
  {
    author: "Epicteto",
    text: "Ámate lo suficiente para no cometer injusticias.",
  },
  {
    author: "Séneca",
    text: "Cada noche es una invitación a reflexionar y agradecer.",
  },
  {
    author: "Marco Aurelio",
    text: "Mantén la cabeza alta y el corazón puro.",
  },
  {
    author: "Epicteto",
    text:
      "No malgastes palabras en reproches; invierte energía en soluciones.",
  },
  {
    author: "Séneca",
    text: "La rectitud moral es un escudo contra el infortunio.",
  },
];